export const SEO = {
  TITLE: 'Flexible Jobs for the Modern Nurse',
  DESCRIPTION:
    'Trusted Health makes it easy for nurses to connect with flexible job opportunities. We’ve replaced the traditional recruiter with our intelligent matching platform---empowering nurses to discover opportunities that fit their unique experiences, preferences, and goals.',
};
